<template>
  <v-row dense class="client-information-form-queue-row" align="start" justify="space-around">
    <v-col cols="auto" class="client-information-form-queue-row-button mt-3">
      <v-btn v-if="showAdd" elevation="0" @click="onAdd" class="d-block mx-auto" fab small>
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-col>
    <v-col cols="auto" class="queues-row-text-field">
      <ValidationProvider name="nombre" rules="required" v-slot="{ errors }">
        <v-text-field
          required
          filled
          rounded
          class="rounded-small"
          dense
          label="Nombre"
          color="blue-grey"
          :value="row.name"
          @input="(newVal) => $emit('data:change', { field: 'name', value: newVal })"
          :error-messages="errors"
        ></v-text-field>
      </ValidationProvider>
    </v-col>
    <v-col cols="auto" class="queues-row-text-field">
      <ValidationProvider name="estrategia" rules="required" v-slot="{ errors }">
        <v-select
          required
          filled
          rounded
          class="rounded-small"
          dense
          label="Estrategia"
          color="blue-grey"
          :value="row.strategy"
          @input="(newVal) => $emit('data:change', { field: 'strategy', value: newVal })"
          :items="strategyOptions"
          :error-messages="errors"
        ></v-select>
      </ValidationProvider>
    </v-col>
    <v-col cols="auto" class="client-information-form-queue-row-button mt-3">
      <v-btn v-if="showDelete" class="d-block mx-auto" @click="onDelete(row.id)" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    showAdd: {
      type: Boolean,
      default: false,
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
    onAdd: {
      type: Function,
    },
    onDelete: {
      type: Function,
    },
    row: {
      type: Object,
    },
  },

  data() {
    return {
      strategyOptions: [
        "ringall",
        "leastrecent",
        "fewestcalls",
        "random",
        "rrmemory",
        "rrordered",
        "linear",
        "wrandom",
      ],
    };
  },
};
</script>

<style>
.queues-row-text-field {
  width: 40%;
  margin: 3px auto;
}

.client-information-form-queue-row-button {
  width: 10%;
}
</style>
